/**
 * Shared error-body parsing for the Workflow Canvas services (workflowConfigService.ts,
 * catalogService.ts) — both hit the same `/shay/email/workflow-config` orchestrator, whose 422
 * body is either `{"detail": "..."}` (plain string) or, for structural graph errors,
 * `{"detail": {"message": "...", "errors": ["...", "..."]}}` (ref: Save API Integration Guide,
 * "Error shapes"). Extracted from two verbatim copies (PR review N1).
 */
export async function parseErrorDetail(response: Response): Promise<string> {
  const body = await response.json().catch(() => ({} as Record<string, unknown>));
  const detail = (body as { detail?: unknown }).detail;
  if (typeof detail === 'string') return detail;
  if (detail && typeof detail === 'object') {
    const { message, errors } = detail as { message?: unknown; errors?: unknown };
    const parts = [
      typeof message === 'string' ? message : null,
      ...(Array.isArray(errors) ? errors.filter((e): e is string => typeof e === 'string') : []),
    ].filter((part): part is string => Boolean(part));
    if (parts.length) return parts.join(' — ');
  }
  return `Request failed (${response.status})`;
}
